import React from 'react';
import AddAppointment from '../components/AddAppointment';

const AppointmentFormPage: React.FC = () => <AddAppointment />;

export default AppointmentFormPage;
